import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const PaymentCancel = () => {
  const location = useLocation();
  
  // Récupérer les paramètres de l'URL
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type') || 'subscription';
  
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body p-4 text-center">
              <div className="text-danger mb-4">
                <i className="bi bi-x-circle" style={{ fontSize: '4rem' }}></i>
              </div>
              <h2 className="mb-3">Paiement annulé</h2>
              <p className="mb-4">
                Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
              </p>
              
              <div className="d-grid gap-2">
                {type === 'subscription' ? (
                  <>
                    <Link to="/subscription-plans" className="btn btn-primary">
                      Retour aux abonnements
                    </Link>
                    <Link to="/profile" className="btn btn-outline-primary">
                      Mon profil
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to="/tournaments" className="btn btn-primary">
                      Retour aux tournois
                    </Link>
                    <Link to="/" className="btn btn-outline-primary">
                      Accueil
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
